import { Stack } from '@mui/material';
import { GridState } from 'ag-grid-community';
import { useEffect, useState } from 'react';

import { useAtomValue } from 'jotai';
import { COMPANY_VIEW_TYPE, VIEW_TYPE } from '../../../data-models/view-config.data-model';
import { ViewModel } from '../../../models/view.model';
import { ViewTitle } from '../components/ViewSections/ViewSections';
import { columnsMetaState, selectedViewPFJ } from '../state/ViewStateJ';
import { MultiPeriodGrid } from './MultiPeriodGrid';
import { useInitializeMprView } from './mprViewActions';

// Reads the view from Jotai because this component is also rendered by
// TempMprWrapper, which doesn't have the view available as a prop.
export function MultiPeriodReportingWrapper() {
  const selectedView = useAtomValue(selectedViewPFJ);
  useAtomValue(columnsMetaState(COMPANY_VIEW_TYPE.RETURN_FORECAST));

  if (!selectedView) {
    return null;
  }
  return <MultiPeriodReporting view={selectedView} />;
}

function MultiPeriodReporting({ view }: { view: ViewModel }) {
  const { id, isDefault, type, name } = view;
  const initializeView = useInitializeMprView(view);
  const [ready, setReady] = useState(false);
  const [initialGridState, setInitialGridState] = useState<GridState>();
  useEffect(() => {
    if (!id || ready) {
      return;
    }
    const { initialized, initialState } = initializeView();
    if (initialized) {
      setInitialGridState(initialState);
      setReady(true);
    }
  }, [initializeView, ready, id]);

  useEffect(() => {
    return () => {
      setReady(false);
      setInitialGridState(undefined);
    };
  }, [id]);

  if (!ready) {
    return null;
  }

  return (
    <Stack width={'100%'} height={'100%'} pb={'1rem'} key={id}>
      <ViewTitle view={view} />
      <MultiPeriodGrid
        initialState={initialGridState}
        id={id}
        viewName={name}
        isDefault={isDefault}
        isShared={type === VIEW_TYPE.SHARED}
      />
    </Stack>
  );
}
